import { Stack, useMediaQuery } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import LoadingPlaceholder from 'components/placeholders/LoadingPlaceholder'
import React from 'react'
import { useTeams } from '../../hooks/useTeams'
import { TimelineTeamMemberItem } from '../TimelineTeamMemberItem/TimelineTeamMemberItem'
import * as Styled from './TimelineTeamMembers.styled'

export function TimelineTeamMembers() {
  const theme = useTheme()
  const matchesXs = useMediaQuery(theme.breakpoints.down('sm'))
  const { isTeamMembersLoading, teamMembersData } = useTeams()

  return (
    <Stack spacing={2} mb={matchesXs ? 0 : '80px'}>
      {teamMembersData.length > 0 && (
        <Styled.TeamMembersTitle variant="h6" gutterBottom>
          Team Members
        </Styled.TeamMembersTitle>
      )}

      {isTeamMembersLoading && <LoadingPlaceholder />}
      {teamMembersData.map((member) => {
        return <TimelineTeamMemberItem key={member.id || member.userId} member={member} />
      })}
    </Stack>
  )
}
